import { render, staticRenderFns } from "./footleft.vue?vue&type=template&id=3c4822ee&scoped=true&"
import script from "./footleft.vue?vue&type=script&lang=js&"
export * from "./footleft.vue?vue&type=script&lang=js&"
import style0 from "./footleft.vue?vue&type=style&index=0&id=3c4822ee&prod&lang=scss&scoped=scoped&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c4822ee",
  null
  
)

export default component.exports